export default function initDesktopMenu() {

    // ==========================================
    // 1. LÓGICA DOS DROPDOWNS (Idiomas e Secundário)
    // ==========================================
    const langDropdown = document.querySelector('.js-lang-dropdown');
    const secondaryDropdown = document.querySelector('.js-secondary-dropdown');

    // Função genérica para fechar todos os dropdowns ativos
    function closeAllDropdowns() {
        if (langDropdown) langDropdown.classList.remove('is-active');
        if (secondaryDropdown) secondaryDropdown.classList.remove('is-active');

        // Reset de ARIA labels
        document.querySelectorAll('.c-lang-dropdown__toggle, .js-toggle-secondary').forEach(el => {
            el.setAttribute('aria-expanded', 'false');
        });
    }

    function updateBrandLogo(panel, logoUrl) {
        const brandDisplay = panel.querySelector('.c-brand-display');
        let logo = panel.querySelector('.js-megamenu-logo');

        if (!logoUrl) {
            if (logo) logo.remove();
            return;
        }

        if (!brandDisplay) return;

        if (!logo) {
            logo = document.createElement('img');
            logo.className = 'c-brand-display__logo js-megamenu-logo';
            logo.alt = 'Logo da Marca';
            brandDisplay.appendChild(logo);
        }

        logo.src = logoUrl;
        logo.style.opacity = '1';
    }

    // Listener Idioma (Funciona Mobile e Desk)
    if (langDropdown) {
        const langToggle = langDropdown.querySelector('.c-lang-dropdown__toggle');
        if (langToggle) {
            langToggle.addEventListener('click', (e) => {
                e.preventDefault(); // Previne qualquer comportamento padrão do botão
                e.stopPropagation(); // Impede que o clique feche imediatamente

                const wasActive = langDropdown.classList.contains('is-active');
                closeAllDropdowns(); // Fecha outros

                if (!wasActive) {
                    langDropdown.classList.add('is-active');
                    langToggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    }

    // Listener Menu Secundário (Apenas Desk)
    if (secondaryDropdown) {
        const secondaryToggle = secondaryDropdown.querySelector('.js-toggle-secondary');
        if (secondaryToggle) {
            secondaryToggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const wasActive = secondaryDropdown.classList.contains('is-active');
                closeAllDropdowns();

                if (!wasActive) {
                    secondaryDropdown.classList.add('is-active');
                    secondaryToggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    }

    // Fechar dropdowns ao clicar fora ou apertar ESC
    document.addEventListener('click', closeAllDropdowns);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAllDropdowns();
    });


    // ==========================================
    // 2. LÓGICA DO MEGA MENU (Hover de Produtos e Marcas)
    // ==========================================
    const megamenuTriggers = document.querySelectorAll('.js-megamenu-trigger');
    const megamenuImageCache = new Map();
    const megamenuVisualRequests = new WeakMap();

    // Inicia o download uma única vez. O hover pode então usar a imagem já em cache.
    function preloadMegamenuImage(url) {
        if (!url) return Promise.resolve('');
        if (megamenuImageCache.has(url)) return megamenuImageCache.get(url);

        const promise = new Promise(resolve => {
            const image = new Image();
            image.onload = () => resolve(url);
            image.onerror = () => resolve('');
            image.src = url;
        });

        megamenuImageCache.set(url, promise);
        return promise;
    }

    function preloadMegamenuPanel(panel) {
        panel.querySelectorAll('.js-megamenu-trigger').forEach(trigger => {
            preloadMegamenuImage(trigger.getAttribute('data-image'));
            preloadMegamenuImage(trigger.getAttribute('data-logo'));
        });
    }

    function updateMegamenuVisual(panel, imageUrl, color, logoUrl) {
        const requestId = (megamenuVisualRequests.get(panel) || 0) + 1;
        megamenuVisualRequests.set(panel, requestId);

        const imageElement = panel.querySelector('.js-megamenu-img');
        const gradientElement = panel.querySelector('.js-megamenu-gradient');

        Promise.all([
            preloadMegamenuImage(imageUrl),
            preloadMegamenuImage(logoUrl),
        ]).then(([loadedImage, loadedLogo]) => {
            // Um hover posterior venceu este carregamento.
            if (megamenuVisualRequests.get(panel) !== requestId) return;

            if (imageElement) {
                if (loadedImage) {
                    imageElement.src = loadedImage;
                    imageElement.style.opacity = '1';
                } else if (!imageUrl) {
                    imageElement.removeAttribute('src');
                    imageElement.style.opacity = '0';
                }
            }

            if (color && gradientElement) {
                gradientElement.style.setProperty('--brand-color', color);
            }

            updateBrandLogo(panel, loadedLogo);
        });
    }

    if (megamenuTriggers.length > 0) {
        megamenuTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', function () {
                const currentPanel = this.closest('.c-menu-panel');
                if (!currentPanel) return;

                // Carrega antecipadamente as imagens do painel para os próximos hovers.
                preloadMegamenuPanel(currentPanel);

                const localTriggers = currentPanel.querySelectorAll('.js-megamenu-trigger');
                const localTargets = currentPanel.querySelectorAll('.js-megamenu-target');

                localTriggers.forEach(item => item.classList.remove('is-active'));
                localTargets.forEach(item => item.classList.remove('is-active'));
                this.classList.add('is-active');

                const targetId = this.getAttribute('data-target');
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) targetElement.classList.add('is-active');
                }

                updateMegamenuVisual(
                    currentPanel,
                    this.getAttribute('data-image'),
                    this.getAttribute('data-color'),
                    this.getAttribute('data-logo')
                );
            });
        });
    }

    // ==========================================
    // LÓGICA DO HOVER INTENT (Safe Triangle) - Menu Principal
    // ==========================================
    const navItems = document.querySelectorAll('.c-nav__item');
    let hoverTimeout; // Variável para guardar o timer
    const delay = 150; // Tempo de tolerância em milissegundos (Ajuste se precisar, 150 a 250 é o padrão ouro)

    navItems.forEach(item => {
        // Quando o mouse ENTRA no item (seja no link ou no próprio painel aberto)
        item.addEventListener('mouseenter', () => {
            // Cancela qualquer timer de fechamento que estivesse rodando
            clearTimeout(hoverTimeout);

            // Começa o carregamento enquanto o menu abre, antes do cursor chegar à lista.
            item.querySelectorAll('.c-menu-panel').forEach(preloadMegamenuPanel);

            // Fecha outros menus que possam estar abertos (evita menus sobrepostos)
            navItems.forEach(sibling => {
                if (sibling !== item) {
                    sibling.classList.remove('is-hovered');
                }
            });

            // Abre o menu atual
            item.classList.add('is-hovered');
        });

        // Quando o mouse SAI do item
        item.addEventListener('mouseleave', () => {
            // Em vez de fechar na hora, inicia uma contagem
            hoverTimeout = setTimeout(() => {
                item.classList.remove('is-hovered');
            }, delay);
        });
    });


}
